module.exports = __webpack_public_path__ + "img/blue_123.6b049e9c.png";